import branch from 'branch-sdk';

class BranchService {
  static BANNER_CONFIG = {
    showiOS: true,
    showiPad: true,
    showAndroid: false,
    showDesktop: false,
    make_new_link: true,
  }

  constructor(key) {
    this.branch = branch;
    if (key) this.init(key);
  }

  init(key) {
    this.branch.init(key, null, (err) => {
      if (!err) this.openBanner();
    });
  }

  openBanner() {
    this.branch.banner(BranchService.BANNER_CONFIG);
  }

  destroy() {
    this.branch.closeJourney();
    this.branch.logout();
  }
}

export default BranchService;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/BranchService.js